export class DocumentDeleteNotification {
	viewId: number;
	folderId: string;

	public static fromJson(other: any): DocumentDeleteNotification {
		const instance = new DocumentDeleteNotification();
		instance.folderId = other.FolderId;
		instance.viewId = other.ViewId;
		return instance;
	}
}
